import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      isScrolled 
        ? 'bg-white/95 backdrop-blur-lg shadow-lg border-b border-gray-200' 
        : 'bg-white/80 backdrop-blur-md border-b border-gray-100'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* RIC Logo */}
          <div className="flex items-center">
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                {/* Diamond Pattern Icon */}
                <svg className="w-10 h-10" viewBox="0 0 40 40" fill="none">
                  <rect x="15" y="5" width="5" height="5" fill="#5B4FC7" rx="1"/>
                  <rect x="20" y="10" width="5" height="5" fill="#5B4FC7" rx="1"/>
                  <rect x="15" y="15" width="5" height="5" fill="#5B4FC7" rx="1"/>
                  <rect x="10" y="10" width="5" height="5" fill="#5B4FC7" rx="1"/>
                  <rect x="25" y="15" width="5" height="5" fill="#5B4FC7" rx="1"/>
                  <rect x="20" y="20" width="5" height="5" fill="#5B4FC7" rx="1"/>
                  <rect x="15" y="25" width="5" height="5" fill="#5B4FC7" rx="1"/>
                  <rect x="10" y="20" width="5" height="5" fill="#5B4FC7" rx="1"/>
                  <rect x="5" y="15" width="5" height="5" fill="#5B4FC7" rx="1"/>
                </svg>
                <div className="flex flex-col">
                  <span className="text-3xl font-bold tracking-tight" style={{color: '#2D2766'}}>RIC</span>
                  <span className="text-xs font-medium" style={{color: '#5B4FC7'}}>Guiding You to Success</span>
                </div>
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            <a href="#services" className="px-4 py-2 text-gray-700 hover:text-indigo-700 font-medium transition rounded-lg hover:bg-indigo-50">
              Services
            </a>
            <a href="#testimonials" className="px-4 py-2 text-gray-700 hover:text-indigo-700 font-medium transition rounded-lg hover:bg-indigo-50">
              Success Stories
            </a>
            <a href="#contact" className="px-4 py-2 text-gray-700 hover:text-indigo-700 font-medium transition rounded-lg hover:bg-indigo-50">
              Contact
            </a>
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <a href="tel:+919505334999" className="text-gray-600 hover:text-indigo-700 font-medium transition">
              +91 95053 34999
            </a>
            <button className="relative group">
              <div className="absolute -inset-0.5 bg-indigo-600 rounded-full blur opacity-75 group-hover:opacity-100 transition"></div>
              <div className="relative bg-indigo-700 hover:bg-indigo-800 text-white px-6 py-2.5 rounded-full font-semibold shadow-lg hover:shadow-xl transition transform group-hover:scale-105">
                Book Free Consultation
              </div>
            </button>
          </div>

          {/* Mobile menu button */}
          <button 
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-700" />
            ) : (
              <Menu className="w-6 h-6 text-gray-700" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-6 space-y-3">
            <a href="#services" className="block px-4 py-3 text-gray-700 hover:text-indigo-700 hover:bg-indigo-50 rounded-lg font-medium transition">
              Services
            </a>
            <a href="#testimonials" className="block px-4 py-3 text-gray-700 hover:text-indigo-700 hover:bg-indigo-50 rounded-lg font-medium transition">
              Success Stories
            </a>
            <a href="#contact" className="block px-4 py-3 text-gray-700 hover:text-indigo-700 hover:bg-indigo-50 rounded-lg font-medium transition">
              Contact
            </a>
            <a href="tel:+919505334999" className="block px-4 py-3 text-indigo-700 font-semibold border-t border-gray-200">
              📞 +91 95053 34999
            </a>
            <button className="w-full bg-indigo-700 hover:bg-indigo-800 text-white px-6 py-3 rounded-lg font-semibold shadow-lg">
              Book Free Consultation
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
